document.addEventListener('bundler:loaded', function (e) {
  console.log('get budlez', window.bndlr.getBundles());
  const activeBundles = window.bndlr.getBundles();

  let volumeDiscounts = [];
  let currentBundle = null;
  let currentProductHandle = document.querySelector('[data-product-handle]').getAttribute('data-product-handle');
  let currentProductId = document.querySelector('[data-product-id]').getAttribute('data-product-id');

  function getDiscountedPrice(quantity, originalPrice) {
    console.log('Original price:', originalPrice);
    console.log('Quantity:', quantity);
    console.log('Volume discounts:', volumeDiscounts);

    for (let i = volumeDiscounts.length - 1; i >= 0; i--) {
      if (quantity >= volumeDiscounts[i].min_items) {
        const discountValue = parseFloat(volumeDiscounts[i].discount_value);
        console.log('Applying discount:', volumeDiscounts[i]);
        if (volumeDiscounts[i].discount_type === 'percentage') {
          const discountedPrice = originalPrice * (1 - discountValue / 100);
          console.log('Discounted price (percentage):', discountedPrice);
          return discountedPrice;
        } else if (volumeDiscounts[i].discount_type === 'fixed_amount') {
          const discountedPrice = Math.max(0, originalPrice - discountValue);
          console.log('Discounted price (fixed amount):', discountedPrice);
          return discountedPrice;
        }
      }
    }
    console.log('No discount applied');
    return originalPrice;
  }

  function displayVolumeDiscounts(volumeDiscounts) {
    const volumeDiscountContainer = document.querySelector('#volume-discount-container');
    if (!volumeDiscountContainer) return;

    volumeDiscountContainer.innerHTML = '';

    volumeDiscounts.forEach((discount) => {
      const quantity = discount.min_items;
      const discountValue = discount.discount_value;
      const discountType = discount.discount_type;

      const originalPrice = parseFloat(volumeDiscountContainer.getAttribute('data-price') || '0');
      let discountedPrice, discountAmount;

      if (discountType === 'percentage') {
        discountedPrice = originalPrice * (1 - discountValue / 100);
        discountAmount = originalPrice - discountedPrice;
      } else if (discountType === 'fixed_amount') {
        discountedPrice = originalPrice - discountValue;
        discountAmount = discountValue;
      }

      // Calculate the total discount by multiplying the discount per item by the quantity
      const totalDiscountAmount = discountAmount * quantity;

      // Format the discounted price (per item) and total discount (for all items)
      const formattedDiscountedPrice = formatMoney(discountedPrice * 100, '€{{amount_with_comma_separator}}');
      const formattedTotalDiscountAmount = formatMoney(totalDiscountAmount * 100, '€{{amount_with_comma_separator}}');

      // Update the HTML to reflect the total discount
      const discountHtml = `
        <div class="flex items-center justify-between bg-white cursor-pointer px-2 sm:px-6 xl:px-10 py-3 sm:py-4 border border-[#DDD9D9] mb-2" data-volume-quantity="${quantity}">
          <div class="flex items-center w-1/4">
            <span class="font-bold underline text-xs md:text-sm">${quantity} stuks</span>
          </div>
          <div class="border-l border-gray-300 h-full mx-4"></div>
          <div class="flex items-center border-x border-[#DDD9D9] px-3 sm:px-6 xl:px-12 justify-center text-xs md:text-sm w-1/2">
            <span><span data-excl-price="${discountedPrice * 100}">${formattedDiscountedPrice}</span> per stuk</span>
          </div>
          <div class="border-l border-gray-300 h-full mx-4"></div>
          <div class="flex items-center justify-end text-light font-bold text-xs md:text-sm w-1/3">
            <span><span data-excl-price="${totalDiscountAmount * 100}">${formattedTotalDiscountAmount}</span> korting</span> <!-- Display total discount -->
          </div>
        </div>
      `;

      volumeDiscountContainer.innerHTML += discountHtml;
    });
  }

  async function displayBundleProducts(products) {
    const bundleSelector = document.querySelector('[data-bundle-selector]');
    if (!bundleSelector) return;

    bundleSelector.innerHTML = '';
    const discountPercentage = parseFloat(currentBundle.percentage_value) / 100;

    // Handle the current product (hidden from frontend)
    const currentProduct = Object.values(products).find((p) => p.handle === currentProductHandle);
    if (currentProduct) {
      const fullProductData = await fetchProductData(currentProduct.handle);
      if (fullProductData) {
        const variant = fullProductData.variants[0]; // Assuming first variant

        const originalPrice = variant.price;
        const discountedPrice = originalPrice * (1 - discountPercentage);

        // Add a hidden element to store current product information
        bundleSelector.innerHTML += `
          <div data-product-id="${currentProduct.id}" data-variant-id="${variant.id}" style="display: none;">
            <input
              type="checkbox"
              checked
              disabled
            >
            <span data-original-price="${originalPrice}" data-discounted-price="${discountedPrice}"></span>
          </div>
        `;

        // Add the current product to the bundle only if it hasn't been added yet
        if (!currentProductAdded) {
          addCurrentProductToBundle(currentProduct.id, variant.id);
        }
      }
    }

    // Display other products in the bundle selector
    for (const product of Object.values(products)) {
      if (product.handle !== currentProductHandle) {
        const fullProductData = await fetchProductData(product.handle);
        if (!fullProductData) continue;

        const variant = fullProductData.variants[0]; // Assuming first variant

        const originalPrice = variant.price;
        const discountedPrice = originalPrice * (1 - discountPercentage);
        const imageUrl = fullProductData.featured_image || 'path/to/default/image.jpg';

        bundleSelector.innerHTML += `
          <div data-product-id="${product.id}" data-variant-id="${
          variant.id
        }" class="min-h-[302px] bg-white relative border border-[#DDD9D9] p-3 col-span-12 lg:col-span-4 flex flex-row xl:flex-col items-center gap-3 md:gap-6 xl:gap-0">
            <div class="flex items-center mb-4 absolute right-3 top-3">
              <input
                type="checkbox"
                class="!mr-0 !w-5 !h-5 text-hightlight_light !rounded-none cursor-pointer"
                onChange="toggleInBundle(event, '${product.id}', '${variant.id}', ${product.sequence})"
              >
            </div>
            <img
              src="${imageUrl}"
              alt="${fullProductData.title}"
              class="w-36 h-36 xl:h-auto xl:w-full object-cover aspect-square xl:mb-4"
              width="200"
              height="200"
            > 
            <div>
              <p class="font-bold text-base md:text-lg mb-1">${fullProductData.title}</p>
              <div class="flex flex-wrap items-center gap-2">
                <p class="text-[#6E6E6E] text-xs line-through">${formatMoney(
                  originalPrice,
                  '€{{amount_with_comma_separator}}'
                )}</p>
                <p class="text-base font-bold" data-original-price="${originalPrice}" data-discounted-price="${discountedPrice}">${formatMoney(
          discountedPrice,
          '€{{amount_with_comma_separator}}'
        )}</p>
              </div>
            </div>
          </div>
        `;
      }
    }
    updateBundlePrice();
  }

  activeBundles.forEach((bundle) => {
    console.log('Checking bundle:', bundle);

    if (bundle.is_volume_bundle === 'true' && bundle.volume_discounts && bundle.volume_discounts.length > 0) {
      // Check if the current product is in this volume discount bundle
      const bundleProduct = Object.values(bundle.products).find((p) => p.handle === currentProductHandle);
      if (bundleProduct) {
        console.log('Volume discount bundle found for current product', bundle);
        volumeDiscounts = bundle.volume_discounts;
        displayVolumeDiscounts(bundle.volume_discounts);
      }
    } else if (bundle.id == 512203) {
      currentBundle = bundle;
      console.log('Regular bundle found', bundle);
      if (Object.values(bundle.products).some((p) => p.handle === currentProductHandle)) {
        displayBundleProducts(bundle.products);
      } else {
        console.log('Product not in bundle');
        const bundlesElement = document.querySelector('#bundles');
        if (bundlesElement) {
          bundlesElement.style.display = 'none';
        }
        const miniMenuLink = document.querySelector('.mini-menu a[href="#bundles"]');
        if (miniMenuLink) {
          miniMenuLink.parentNode.style.display = 'none';
        }
      }
    }
  });

  // Add an event listener to the quantity input
  const quantityInput = document.querySelector('[action="/cart/add"] .product-form__quantity input');
  const totalPriceElement = document.getElementById('total-price');
  const originalPrice = parseFloat(totalPriceElement.getAttribute('data-original-price'));

  // Modify the event listener for the quantity input
  if (quantityInput && totalPriceElement) {
    quantityInput.addEventListener('change', function () {
      console.log('Quantity changed');
      const quantity = parseInt(this.value, 10);
      const originalPrice = parseFloat(totalPriceElement.getAttribute('data-original-price'));
      console.log('Original price from attribute:', originalPrice);
      const discountedPrice = getDiscountedPrice(quantity, originalPrice);
      const totalPrice = discountedPrice * quantity;

      console.log('Calculated total price:', totalPrice);
      totalPriceElement.textContent = formatMoney(totalPrice * 100, '€{{amount_with_comma_separator}}');
      totalPriceElement.setAttribute('data-excl-price', totalPrice * 100);
    });
  }

  // Modify the setQuantity function
  window.setQuantity = function (quantity) {
    console.log('Set quantity: ', quantity);
    quantityInput.value = quantity;
    const originalPrice = parseFloat(totalPriceElement.getAttribute('data-original-price'));
    console.log('Original price from attribute:', originalPrice);
    const discountedPrice = getDiscountedPrice(quantity, originalPrice);
    const totalPrice = discountedPrice * quantity;
    console.log('Calculated total price:', totalPrice);
    totalPriceElement.textContent = formatMoney(totalPrice * 100, '€{{amount_with_comma_separator}}');
  };

  // Keep existing functions
  async function fetchProductData(handle) {
    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching product data:', error);
      return null;
    }
  }

  let currentProductAdded = false;

  function addCurrentProductToBundle(productId, variantId) {
    const product = document.querySelector(`.bndlr-product.bndlr-mix-and-match[data-product-id="${productId}"]`);
    if (product) {
      const addButton = product.querySelector('.bndlr-add-to-bundle');
      if (addButton) {
        addButton.click();
        currentProductAdded = true;
        console.log('Current product added to bundle');
      } else {
        console.error(`Add button not found for current product: ${productId}`);
      }
    } else {
      console.error(`Product element not found for current product: ${productId}`);
    }
  }

  window.toggleInBundle = function (event, productId, variantId, index) {
    console.log('event', event.target.checked);
    console.log('productId', productId);

    const product = document.querySelector(`.bndlr-product.bndlr-mix-and-match[data-product-id="${productId}"]`);
    console.log(product);

    if (!product) {
      console.error(`Product element not found for productId: ${productId}`);
      return;
    }

    if (event.target.checked) {
      const addButton = product.querySelector('.bndlr-add-to-bundle');
      if (addButton) {
        addButton.click();
      } else {
        console.error(`Add button not found for productId: ${productId}`);
      }
    } else {
      const targetProduct = document.querySelector(
        `.bndlr-mnm-selected-products .bndlr-product[data-variant-id="${variantId}"]`
      );
      if (targetProduct) {
        const removeButton = targetProduct.querySelector('.bndlr-close');
        if (removeButton) {
          removeButton.click();
        } else {
          console.error(`Remove button not found for variantId: ${variantId}`);
        }
      } else {
        console.error(`Target product not found for variantId: ${variantId}`);
      }
    }

    updateBundlePrice();
  };

  window.updateBundlePrice = function () {
    if (!currentBundle) return;

    var bundleContainer = document.getElementById('bundles');
    var productPrice = bundleContainer.getAttribute('data-main-product-price');

    const mainProductPrice = parseFloat(productPrice);
    let totalPrice = 0;

    const allProducts = document.querySelectorAll('[data-bundle-selector] [data-product-id]');
    const checkedProducts = document.querySelectorAll('[data-bundle-selector] input[type="checkbox"]:checked');

    checkedProducts.forEach((checkbox) => {
      const productElement = checkbox.closest('[data-product-id]');
      const price = parseFloat(
        productElement.querySelector('[data-discounted-price]').getAttribute('data-discounted-price')
      );
      totalPrice += price;
    });

    const bundlePriceElement = document.querySelector('[data-bundle-price]');
    bundlePriceElement.innerHTML = formatMoney(totalPrice, '€{{amount_with_comma_separator}}');

    allProducts.forEach((productElement) => {
      if (productElement.style.display !== 'none') {
        const checkbox = productElement.querySelector('input[type="checkbox"]');
        const priceElement = productElement.querySelector('[data-discounted-price]');
        const originalPrice = parseFloat(priceElement.getAttribute('data-original-price'));
        const discountedPrice = parseFloat(priceElement.getAttribute('data-discounted-price'));

        if (checkbox.checked) {
          priceElement.textContent = formatMoney(discountedPrice, '€{{amount_with_comma_separator}}');
          priceElement.classList.add('text-green-500');
        } else {
          priceElement.textContent = formatMoney(discountedPrice, '€{{amount_with_comma_separator}}');
          priceElement.classList.remove('text-green-500');
        }
      }
    });
  };

  window.addBundleToCart = function () {
    // First, ensure the current product is added to the bundle
    const currentProductCheckbox = document.querySelector(
      '[data-bundle-selector] [data-product-id] input[type="checkbox"]:disabled'
    );
    if (currentProductCheckbox) {
      const productId = currentProductCheckbox.closest('[data-product-id]').getAttribute('data-product-id');
      const variantId = currentProductCheckbox.closest('[data-variant-id]').getAttribute('data-variant-id');
      const addButton = document.querySelector(
        `.bndlr-product.bndlr-mix-and-match[data-product-id="${productId}"] .bndlr-add-to-bundle`
      );
      if (addButton) {
        addButton.click();
      }
    }

    // Then add the rest of the bundle to cart
    const atcButton = document.querySelector('.bndlr-add-bundle-to-cart');
    atcButton.click();
  };

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '€{{amount}}';

    function defaultOption(opt, def) {
      return typeof opt == 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, '.');
      decimal = defaultOption(decimal, ',');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? decimal + parts[1] : '';

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }
});
